<template>
  <div class="modal-dialog modal-xl" role="document">
    <div class="jumbotron">
      <h5 class="modal-title">Benutzer registrieren</h5>
      <hr class="my-4">
      <p>Hier können Sie sich als Benutzer für die QR Code Bezahlfunktion registrieren.
        Sie erhalten eine Email mit einem Aktivierungslink und danach (falls Sie noch
        kein Login bei TiBTiX haben) ein Email mit einem temporären Passwort, um sich
        anzumelden. Nach dem ersten Login werden Sie aufgefordert, das temporäre Passwort
        durch ein persönliches Passwort zu ersetzen.
      </p>
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Benutzer registrieren</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="cancel"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="exampleFormControlInput1">Email</label>
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="name@example.com"
              v-model="journalEntry.email"
            />
          </div>
          <div class="form-group">
            <label for="firstName">Vorname</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              placeholder="First Name"
              v-model="journalEntry.firstName"
            />
          </div>
          <div class="form-group">
            <label for="lastName">Name</label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              placeholder="Name"
              v-model="journalEntry.lastName"
            />
          </div>
          <div class="form-group">
            <label for="phoneNr">Telefonnummer (optional)</label>
            <input
              type="text"
              class="form-control"
              id="phoneNr"
              placeholder="+41 61 555 5555"
              v-model="journalEntry.phoneNr"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="row mx-auto">
          <div class="col-xs-6 mx-1">
            <button
              @click="save()"
              type="button"
              class="btn btn-outline-dark btn-block"
              v-bind:class="{disabled: disableButton}"
            >
              <i class="far fa-save"></i>&nbsp;Speichern
            </button>
          </div>
          <div class="col-xs-6 mx-1">
            <button
              @click="cancel()"
              type="button"
              class="btn btn-outline-dark btn-block"
              data-dismiss="modal"
            >
              <i class="far fa-times-circle"></i>&nbsp;Abbrechen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emptyJournalEntry } from "@/common/constants";
import { stringCompare, validEmail, getCookie } from "@/common/utils";

export default {
  name: "journalOnboardComponent",
  data: function() {
    return {
      journalEntry: emptyJournalEntry,
      disableButton: true
    };
  },
  watch: {
    journalEntry: {
      deep: true,

      handler() {
        if (this.journalEntry.firstName.trim().length > 0
          && this.journalEntry.lastName.trim().length > 0
          && validEmail(this.journalEntry.email)) {
          this.disableButton = false;
        } else {
          this.disableButton = true;
        }
      }
    }
  },
  mounted() {
    if (this.journalEntryProperty) {
      this.journalEntry = this.journalEntryProperty;
    } else {
      this.prepareJournalEntry();
    }
  },
  methods: {
    newMessage(text) {
      this.prepareJournalEntry();
      this.journalEntry.text = text;
    },
    prepareJournalEntry() {
      this.journalEntry = JSON.parse(JSON.stringify(emptyJournalEntry));
      this.journalEntry.private = true;
      this.journalEntry.journalType = "onboard";
      this.journalEntry.text = "Willkommen beim QR Code Bezahlsystem. Damit Sie Produkte bezahlen können, müssen Sie zuerst Geld auf Ihr Konto laden. Scannen Sie zu diesem Zweck den Kleber am Automaten. Melden Sie sich an und folgen Sie den entsprechenden Anweisungen. \nWelcome to the QR Code Payment solution. Before you can actually buy products, you need to deposit money to your account. Scan the QR code on the vending machine login and follow the instructions.";
    },
    save() {
      this.$emit("savejournalentry", this.journalEntry);
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  props: {
    journalEntryProperty: Object,
    loggedIn: Boolean,
    tp: Object
  }
};
</script>
